(function () {
  var SECTION_ID = window.LabLocatorId;
  var API_BASE = "https://vital-psc-proxy.tommy-62a.workers.dev";
  var LABCORP_ID = 5;
  var BIOREFERENCE_ID = 14;

  var root = document.querySelector('[data-section-id="' + SECTION_ID + '"]');
  if (!root) return;

  /* ----- DOM refs ----- */
  var zipInput = root.querySelector(".testie-lab-locator__zip-input");
  var radiusSelect = root.querySelector(".testie-lab-locator__radius-select");
  var searchBtn = root.querySelector(".testie-lab-locator__search-btn");
  var resultsHeader = root.querySelector(".testie-lab-locator__results-header");
  var resultsCount = root.querySelector(".testie-lab-locator__results-count");
  var content = root.querySelector(".testie-lab-locator__content");
  var listContainer = root.querySelector(".testie-lab-locator__list");
  var emptyState = root.querySelector(".testie-lab-locator__empty");
  var loadingState = root.querySelector(".testie-lab-locator__loading");
  var initialState = root.querySelector(".testie-lab-locator__initial");
  var errorState = root.querySelector(".testie-lab-locator__error");
  var riBlockedState = root.querySelector(".testie-lab-locator__ri-blocked");
  var cardTemplate = document.getElementById("lab-card-template-" + SECTION_ID);

  var sectionEl = root.closest(".shopify-section") || root.parentElement;
  var stickyBar = sectionEl.querySelector(".testie-lab-locator__sticky-bar");
  var stickyName = stickyBar.querySelector(".testie-lab-locator__sticky-name");
  var stickyAddress = stickyBar.querySelector(
    ".testie-lab-locator__sticky-address",
  );
  var continueBtn = stickyBar.querySelector(
    ".testie-lab-locator__continue-btn",
  );

  /* ----- State ----- */
  var labs = [];
  var selectedLab = null;
  var leafletMap = null;
  var mapMarkers = [];
  var lastSearchZip = "";

  /* ----- Product card refs ----- */
  var productCard = root.querySelector(".testie-lab-locator__product-card");
  var productImg = root.querySelector(".testie-lab-locator__product-img");
  var productName = root.querySelector(".testie-lab-locator__product-name");
  var productTests = root.querySelector(".testie-lab-locator__product-tests");
  var productPrice = root.querySelector(".testie-lab-locator__product-price");

  var PRODUCT_TESTS_MAP = {
    "2-panel-test": ["Chlamydia", "Gonorrhea"],
    "8-panel-test": [
      "Chlamydia",
      "Gonorrhea",
      "Trichomoniasis",
      "Hepatitis B",
      "Hepatitis C",
      "HIV 1",
      "HIV 2",
      "Syphilis",
    ],
    "4-panel-test": [
      "Chlamydia",
      "Gonorrhea",
      "Mycoplasma Genitalium",
      "Bacterial Vaginosis",
    ],
    "the-essentials-ny-nj": ["Chlamydia", "Gonorrhea"],
    "emerging-four-ny-nj": [
      "Chlamydia",
      "Gonorrhea",
      "Mycoplasma Genitalium",
      "Bacterial Vaginosis",
    ],
    "peace-of-mind-ny-nj": [
      "Chlamydia",
      "Gonorrhea",
      "Trichomoniasis",
      "Syphilis",
      "HIV 1",
      "HIV 2",
      "Hepatitis B",
      "Hepatitis C",
      "Herpes I",
      "Herpes II",
    ],
  };

  // USE FOR STEP 2
  /* Handle mapping: default ↔ NY/NJ */
  var TO_NYNJ = {
    "2-panel-test": "the-essentials-ny-nj",
    "4-panel-test": "emerging-four-ny-nj",
    "8-panel-test": "peace-of-mind-ny-nj",
  };
  var TO_DEFAULT = {
    "the-essentials-ny-nj": "2-panel-test",
    "emerging-four-ny-nj": "4-panel-test",
    "peace-of-mind-ny-nj": "8-panel-test",
  };

  /* Swap cart item to the correct regional product if needed */
  function swapCartIfNeeded(needsNyNj) {
    return fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) return;

        //   {% comment %} USE FOR STEP 2 {% endcomment %}
        var item = cart.items[0];
        var handle = item.handle;
        var swapTo = null;

        //   {% comment %} USE FOR STEP 2 {% endcomment %}
        if (needsNyNj && TO_NYNJ[handle]) {
          swapTo = TO_NYNJ[handle];
        } else if (!needsNyNj && TO_DEFAULT[handle]) {
          swapTo = TO_DEFAULT[handle];
        }

        if (!swapTo) return;

        /* Fetch the replacement product, clear cart, add new item */
        return fetch("/products/" + swapTo + ".js")
          .then(function (r) {
            return r.json();
          })
          .then(function (product) {
            var variantId = product.variants[0].id;
            return fetch("/cart/clear.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
            })
              .then(function () {
                return fetch("/cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    items: [{ id: variantId, quantity: 1 }],
                  }),
                });
              })
              .then(function () {
                /* Refresh the product summary card */
                loadProductCard();
              });
          });
      })
      .catch(function (err) {
        console.error("Cart swap error:", err);
      });
  }

  /* ----- Day name mapping ----- */
  var DAY_MAP = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };
  var DAY_ORDER = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  /* ========================================
       UI STATE HELPERS
    ======================================== */
  function showState(state) {
    initialState.style.display = "none";
    loadingState.style.display = "none";
    emptyState.style.display = "none";
    errorState.style.display = "none";
    riBlockedState.style.display = "none";
    resultsHeader.style.display = "none";
    content.style.display = "none";

    if (state === "initial") initialState.style.display = "block";
    else if (state === "loading") loadingState.style.display = "block";
    else if (state === "empty") emptyState.style.display = "block";
    else if (state === "error") errorState.style.display = "block";
    else if (state === "ri-blocked") riBlockedState.style.display = "block";
    else if (state === "results") {
      resultsHeader.style.display = "flex";
      content.style.display = "grid";
    }
  }

  /* ========================================
       TRANSFORM API DATA
    ======================================== */
  /* Determine if a zip code is in NY or NJ */
  function isNyNjZip(zip) {
    var prefix = parseInt(zip.substring(0, 3), 10);
    /* NY: 100–149, NJ: 070–089 */
    return (prefix >= 100 && prefix <= 149) || (prefix >= 70 && prefix <= 89);
  }

  function transformLab(psc, labNetwork) {
    var m = psc.metadata;
    var address = m.first_line;
    if (m.second_line && m.second_line.trim()) {
      address += ", " + m.second_line.trim();
    }

    /* Display name: "Labcorp - City" or "BioReference - City" */
    var displayName = labNetwork;
    if (m.city) {
      var city = m.city.toLowerCase().replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
      displayName = labNetwork + " - " + city;
    }

    return {
      id: psc.site_code,
      name: displayName,
      address: address,
      city: m.city
        ? m.city.toLowerCase().replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          })
        : "",
      state: m.state || "",
      zip: m.zip_code || "",
      phone: m.phone_number || "",
      distance: psc.distance,
      hours: m.hours || {},
      lat: psc.location ? psc.location.lat : null,
      lng: psc.location ? psc.location.lng : null,
    };
  }

  /* ========================================
       API SEARCH
    ======================================== */
  function handleSearch() {
    var zip = zipInput.value.trim();
    var radius = radiusSelect.value;

    /* Validate: zip is required and must be 5 digits */
    if (!zip || zip.length !== 5 || !/^\d{5}$/.test(zip)) {
      zipInput.setAttribute("aria-invalid", "true");
      zipInput.focus();
      return;
    }
    zipInput.removeAttribute("aria-invalid");

    /* Block Rhode Island zip codes (028xx, 029xx) */
    if (/^02[89]/.test(zip)) {
      showState("ri-blocked");
      return;
    }

    lastSearchZip = zip;

    /* Show loading */
    showState("loading");

    /* NY/NJ zips → BioReference, all others → Labcorp */
    var needsNyNj = isNyNjZip(zip);
    var labId = needsNyNj ? BIOREFERENCE_ID : LABCORP_ID;

    /* Swap cart product to match the region */
    swapCartIfNeeded(needsNyNj);

    var url =
      API_BASE +
      "?zip_code=" +
      encodeURIComponent(zip) +
      "&radius=" +
      encodeURIComponent(radius) +
      "&lab_id=" +
      labId;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error("API returned " + response.status);
        return response.json();
      })
      .then(function (data) {
        var centers = data.patient_service_centers || [];
        var labNetwork = needsNyNj ? "BioReference" : "Labcorp";
        labs = centers.map(function (psc) {
          return transformLab(psc, labNetwork);
        });

        /* Sort by distance */
        labs.sort(function (a, b) {
          return a.distance - b.distance;
        });

        if (labs.length === 0) {
          showState("empty");
        } else {
          renderResults();
          updateMap();
          showState("results");
        }
      })
      .catch(function (err) {
        console.error("Lab API error:", err);
        showState("error");
      });
  }

  /* ========================================
       RENDER CARDS
    ======================================== */
  function renderResults() {
    listContainer.innerHTML = "";

    var radius = radiusSelect.value;
    resultsCount.textContent =
      labs.length +
      " location" +
      (labs.length !== 1 ? "s" : "") +
      " found within " +
      radius +
      " miles";

    var todayShort = new Date().toLocaleDateString("en-US", {
      weekday: "short",
    });
    /* Map "Mon" style to match API keys */

    labs.forEach(function (lab, index) {
      var fragment = cardTemplate.content.cloneNode(true);
      var card = fragment.firstElementChild;

      card.dataset.labId = lab.id;
      card.querySelector(".testie-lab-locator__pin-number").textContent =
        index + 1;
      card.querySelector(".testie-lab-locator__card-name").textContent =
        lab.name;
      card.querySelector(".testie-lab-locator__card-distance").textContent =
        lab.distance + " mi away";

      /* Address & phone */
      var fullAddress =
        lab.address + ", " + lab.city + ", " + lab.state + " " + lab.zip;
      card.querySelector(".testie-lab-locator__card-address").textContent =
        fullAddress;

      var phoneLink = card.querySelector(".testie-lab-locator__card-phone a");
      if (lab.phone) {
        phoneLink.href = "tel:" + lab.phone.replace(/[^0-9+]/g, "");
        phoneLink.textContent = lab.phone;
      } else {
        phoneLink.parentElement.style.display = "none";
      }

      /* Hours */
      var hoursList = card.querySelector(
        ".testie-lab-locator__card-hours-list",
      );
      DAY_ORDER.forEach(function (dayKey) {
        var row = document.createElement("div");
        row.className = "testie-lab-locator__card-hours-row";
        if (dayKey === todayShort) {
          row.className += " testie-lab-locator__card-hours-row--today";
        }
        var daySpan = document.createElement("span");
        daySpan.textContent = DAY_MAP[dayKey];
        var timeSpan = document.createElement("span");
        var timeVal = lab.hours[dayKey] || "Closed";
        /* Clean up semicolons in hours like "8:30AM - 12:30PM;1:00PM - 5:00PM" */
        timeSpan.textContent = timeVal.replace(/;/g, ", ");
        row.appendChild(daySpan);
        row.appendChild(timeSpan);
        hoursList.appendChild(row);
      });

      /* Directions link */
      var directionsLink = card.querySelector(
        ".testie-lab-locator__directions-link",
      );
      directionsLink.href =
        "https://www.google.com/maps/dir/?api=1&destination=" +
        encodeURIComponent(fullAddress);

      /* Select button */
      card
        .querySelector(".testie-lab-locator__select-btn")
        .addEventListener("click", function (e) {
          e.stopPropagation();
          selectLab(lab, card);
        });

      /* Whole card click */
      card.addEventListener("click", function (e) {
        if (
          e.target.closest("a") ||
          e.target.closest("button") ||
          e.target.closest("summary")
        )
          return;
        selectLab(lab, card);
      });

      /* Keyboard support */
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          if (
            e.target.closest("a") ||
            e.target.closest("button") ||
            e.target.closest("summary")
          )
            return;
          e.preventDefault();
          selectLab(lab, card);
        }
      });

      /* Restore previous selection */
      if (selectedLab && selectedLab.id === lab.id) {
        card.classList.add("testie-lab-locator__card--selected");
        var btnSpan = card.querySelector(
          ".testie-lab-locator__select-btn span",
        );
        if (btnSpan) btnSpan.textContent = "Selected";
      }

      listContainer.appendChild(card);
    });
  }

  /* ========================================
       MAP (LEAFLET)
    ======================================== */
  function initMap() {
    if (leafletMap) return;
    var mapEl = document.getElementById("lab-map-" + SECTION_ID);
    if (!mapEl || typeof L === "undefined") return;

    leafletMap = L.map(mapEl, {
      zoomControl: true,
      scrollWheelZoom: true,
    }).setView([39.8283, -98.5795], 4); /* Default: center of US */

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(leafletMap);
  }

  function updateMap() {
    initMap();
    if (!leafletMap) return;

    /* Clear existing markers */
    mapMarkers.forEach(function (m) {
      leafletMap.removeLayer(m);
    });
    mapMarkers = [];

    if (labs.length === 0) return;

    var bounds = L.latLngBounds();

    labs.forEach(function (lab, index) {
      if (!lab.lat || !lab.lng) return;

      var icon = L.divIcon({
        className: "testie-lab-locator__marker-wrapper",
        html:
          '<div class="testie-lab-locator__marker" data-marker-id="' +
          lab.id +
          '">' +
          (index + 1) +
          "</div>",
        iconSize: [32, 32],
        iconAnchor: [16, 16],
      });

      var marker = L.marker([lab.lat, lab.lng], { icon: icon }).addTo(
        leafletMap,
      );

      /* Popup with lab info */
      var popupContent =
        "<strong>" +
        lab.name +
        "</strong><br>" +
        lab.address +
        ", " +
        lab.city +
        ", " +
        lab.state +
        " " +
        lab.zip;
      if (lab.phone) popupContent += "<br>" + lab.phone;
      marker.bindPopup(popupContent);

      /* Click marker to select lab */
      marker.on("click", function () {
        var cardEl = listContainer.querySelector(
          '[data-lab-id="' + lab.id + '"]',
        );
        if (cardEl) {
          selectLab(lab, cardEl);
          cardEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      });

      marker._labId = lab.id;
      mapMarkers.push(marker);
      bounds.extend([lab.lat, lab.lng]);
    });

    /* Fit map to show all markers with padding */
    if (bounds.isValid()) {
      leafletMap.fitBounds(bounds, { padding: [40, 40], maxZoom: 13 });
    }

    /* Invalidate size in case map container was hidden */
    setTimeout(function () {
      leafletMap.invalidateSize();
    }, 100);
  }

  function highlightMarker(labId) {
    mapMarkers.forEach(function (marker) {
      var el = marker.getElement();
      if (!el) return;
      var pin = el.querySelector(".testie-lab-locator__marker");
      if (!pin) return;
      if (marker._labId === labId) {
        pin.classList.add("testie-lab-locator__marker--active");
      } else {
        pin.classList.remove("testie-lab-locator__marker--active");
      }
    });
  }

  /* ========================================
       SELECTION
    ======================================== */
  function selectLab(lab, cardElement) {
    /* Deselect previous */
    var prev = listContainer.querySelector(
      ".testie-lab-locator__card--selected",
    );
    if (prev) {
      prev.classList.remove("testie-lab-locator__card--selected");
      var prevBtn = prev.querySelector(".testie-lab-locator__select-btn span");
      if (prevBtn) prevBtn.textContent = "Select Lab";
    }

    /* Toggle off if same lab */
    if (selectedLab && selectedLab.id === lab.id) {
      selectedLab = null;
      highlightMarker(null);
      hideStickyBar();
      return;
    }

    /* Select new */
    selectedLab = lab;
    cardElement.classList.add("testie-lab-locator__card--selected");
    var btnSpan = cardElement.querySelector(
      ".testie-lab-locator__select-btn span",
    );
    if (btnSpan) btnSpan.textContent = "Selected";

    highlightMarker(lab.id);
    showStickyBar(lab);
  }

  function showStickyBar(lab) {
    stickyName.textContent = lab.name;
    stickyBar.style.display = "block";
    void stickyBar.offsetHeight;
    stickyBar.classList.add("testie-lab-locator__sticky-bar--visible");
  }

  function hideStickyBar() {
    stickyBar.classList.remove("testie-lab-locator__sticky-bar--visible");
    setTimeout(function () {
      if (
        !stickyBar.classList.contains("testie-lab-locator__sticky-bar--visible")
      ) {
        stickyBar.style.display = "none";
      }
    }, 300);
  }

  /* ========================================
       CART WRITE & CHECKOUT
    ======================================== */
  continueBtn.addEventListener("click", function () {
    if (!selectedLab) return;

    var btnSpan = continueBtn.querySelector("span");
    continueBtn.disabled = true;
    btnSpan.textContent = "Saving...";

    var fullAddress =
      selectedLab.address +
      ", " +
      selectedLab.city +
      ", " +
      selectedLab.state +
      " " +
      selectedLab.zip;

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          lab_id: selectedLab.id,
          lab_name: selectedLab.name,
          lab_address: fullAddress,
          lab_phone: selectedLab.phone,
        },
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to save lab selection");
        if (selectedLab.state === "NJ" || selectedLab.state === "NY") {
          window.location.href = "/pages/pick-a-panel-ny-nj";
        } else {
          window.location.href = "/pages/pick-a-panel";
        }
      })
      .catch(function (error) {
        console.error("Lab selection error:", error);
        continueBtn.disabled = false;
        btnSpan.textContent = "Continue";
      });
  });

  /* ========================================
       PRODUCT SUMMARY CARD
    ======================================== */
  function loadProductCard() {
    fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) return;

        /* Find the first item that matches a known test panel */
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (PRODUCT_TESTS_MAP.hasOwnProperty(cart.items[i].handle)) {
            item = cart.items[i];
            break;
          }
        }
        if (!item) return;

        if (productImg && item.image) {
          productImg.src = item.image;
          productImg.alt = item.product_title;
          productCard
            .querySelector(".testie-lab-locator__product-title-row")
            .style.setProperty("--product-img-url", "url(" + item.image + ")");
        }

        if (productName) {
          productName.textContent = item.product_title;
        }

        if (productPrice) {
          productPrice.textContent = "$" + item.price / 100;
        }

        if (productTests) {
          var tests = PRODUCT_TESTS_MAP[item.handle] || [];
          productTests.innerHTML = "";
          tests.forEach(function (test) {
            var span = document.createElement("span");
            span.className = "testie-lab-locator__product-test-item";
            span.textContent = "\u2713 " + test;
            productTests.appendChild(span);
          });
        }

        productCard.style.display = "block";
      })
      .catch(function (err) {
        console.error("Failed to load cart:", err);
      });
  }

  /* ========================================
       EVENT LISTENERS
    ======================================== */
  searchBtn.addEventListener("click", handleSearch);
  zipInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  });

  /* ========================================
     BFCACHE / BACK-NAVIGATION RESET
  ======================================== */
  function resetStickyBarImmediate() {
    var btnSpan = continueBtn.querySelector("span");
    continueBtn.disabled = false;
    btnSpan.textContent = "Continue";
  }

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      resetStickyBarImmediate();
    }
  });

  /* ========================================
      INIT — check for query params (zip/radius) from
      the search-bar block redirect, otherwise show initial state
    ======================================== */
  function initFromQueryParams() {
    var params = new URLSearchParams(window.location.search);
    var zip = params.get("zip");
    var radius = params.get("radius");

    if (radius && ["10", "25", "50", "100"].indexOf(radius) !== -1) {
      radiusSelect.value = radius;
    }

    if (zip && /^\d{5}$/.test(zip)) {
      zipInput.value = zip;
      handleSearch();
      return true;
    }
    return false;
  }

  if (!initFromQueryParams()) {
    showState("initial");
  }
  resetStickyBarImmediate();
  loadProductCard();
})();
